import { render, staticRenderFns } from "./InvestigatorDetailInput.vue?vue&type=template&id=745238e8&scoped=true"
import script from "./InvestigatorDetailInput.vue?vue&type=script&lang=js"
export * from "./InvestigatorDetailInput.vue?vue&type=script&lang=js"
import style0 from "./InvestigatorDetailInput.vue?vue&type=style&index=0&id=745238e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745238e8",
  null
  
)

export default component.exports